<modal #modalChangeGroup [backdrop]="true" class="modal-change-group">
  <modal-content>
    <h4 class="title">Selecione um novo grupo:</h4>
    <div class="row flex">
      <div class="col-md-6">
        <ss-multiselect-dropdown #select
          [texts]="selectTexts"
          [options]="optionsUnit"
          [settings]="settingsSelectUnit"
          [(ngModel)]="selectedOption"
          (ngModelChange)="select.clickedOutside()">
        </ss-multiselect-dropdown>
      </div>
    </div>
    <div class="btn-row">
      <button class="btn btn-orange" [disabled]="!selectedOption.length" (click)="saveChange()">
        Salvar
      </button>
    </div>
  </modal-content>
</modal>
